import { createContext } from 'react';

const SnackbarContext = /*#__PURE__*/createContext({
  createSnackbar: () => {}
});
const SnackbarConsumer = SnackbarContext.Consumer;

export { SnackbarConsumer, SnackbarContext };
//# sourceMappingURL=SnackbarContext.mjs.map
